import React, { Dispatch, SetStateAction } from 'react'
import { BeneficiaryType } from 'types/beneficiary'
import BtnUpdate from '../../assets/iconUpdateBenef.svg'
import btnDeleted from '../../assets/iconDelete.svg'
import BtnService from '../../assets/iconServiceEasy.svg'
import Avatar from 'components/avatar'
interface  Props{
    beneficiary:BeneficiaryType
    setAction:Dispatch<SetStateAction<'delete' | 'update' | 'service' | null> >

    setSelectedBeneficiary:(val:BeneficiaryType)=>void
}

const CardBeneficiary: React.FC<Props> = ({beneficiary, setAction, setSelectedBeneficiary}) => {
  return (
    <div className={`w-[210px] h-[330px] group sm:w-[250px] flex flex-col items-center justify-between py-[40px] px-[24px] 
        rounded-[14px]  hover:shadow-[0_6px_20px_rgba(87,84,229,0.1)]  hover:border hover:border-[#D1D1FF] `}
    >
        <div className='flex flex-col items-center cursor-default  '>
            <Avatar styleCss='w-[120px] h-[120px] sm:w-[100px] sm:h-[100px]' avatar={beneficiary.avatar} />
            <div className='text-[#0A0A0A] text-[18px] text-center'>
              {`${beneficiary?.personalInfo?.lastName}`.length > 8
                  ? `${beneficiary?.personalInfo?.firstName?.slice(0, 15)}...`
                  : `${beneficiary?.personalInfo?.firstName} ${beneficiary?.personalInfo?.lastName}`}
            </div>
            <div className='text-[#B4B4B4] text-[14px]'>{beneficiary.personalInfo.phone.prefix} {beneficiary.personalInfo.phone.number}</div>
        </div>
       
            <div className="  items-end justify-end gap-1 mt-4 hidden group-hover:flex">
                <img
                  className=" hover:cursor-pointer "
                  onClick={() => {
                    setAction('delete')
                    setSelectedBeneficiary(beneficiary)
                   }}
                  src={btnDeleted}
                />

                <button
                  className=" rounded-lg flex items-center justify-center cursor-pointer"
                  onClick={() => {
                    setAction('update')
                    setSelectedBeneficiary(beneficiary)
                  }}
                  aria-label="Modifier Bénéficiaire"
                >
                  <img src={BtnUpdate} alt="" />
                </button>

                <img
                  className=" hover:cursor-pointer "
                  onClick={() => {
                    setAction('service')
                    setSelectedBeneficiary(beneficiary)
                }}
            
                  src={BtnService}
                />
            </div>
     
    </div>
  )
}

export default CardBeneficiary
